import type * as Types from '../../../schemas/shopify/admin.types';

export type MarketWebPresenceRootUrlNodeFragment = Pick<
  Types.MarketWebPresenceRootUrl,
  'url' | 'locale'
>;

export type MarketWebPresenceNodeFragment = {
  rootUrls: Array<Pick<Types.MarketWebPresenceRootUrl, 'url' | 'locale'>>;
};

export type MarketWebPresenceEdgesFragment = {
  edges: Array<
    Pick<Types.MarketWebPresenceEdge, 'cursor'> & {
      node: { rootUrls: Array<Pick<Types.MarketWebPresenceRootUrl, 'url' | 'locale'>> };
    }
  >;
};

export type MarketNodeFragment = Pick<Types.Market, 'id' | 'name' | 'handle'> & {
  webPresences: {
    edges: Array<
      Pick<Types.MarketWebPresenceEdge, 'cursor'> & {
        node: { rootUrls: Array<Pick<Types.MarketWebPresenceRootUrl, 'url' | 'locale'>> };
      }
    >;
  };
};

export type MarketEdgesFragment = {
  edges: Array<
    Pick<Types.MarketEdge, 'cursor'> & {
      node: Pick<Types.Market, 'id' | 'name' | 'handle'> & {
        webPresences: {
          edges: Array<
            Pick<Types.MarketWebPresenceEdge, 'cursor'> & {
              node: { rootUrls: Array<Pick<Types.MarketWebPresenceRootUrl, 'url' | 'locale'>> };
            }
          >;
        };
      };
    }
  >;
};

export const MarketWebPresenceRootUrlNodeFragmentDoc = `
    fragment MarketWebPresenceRootUrlNode on MarketWebPresenceRootUrl {
  url
  locale
}
    `;
export const MarketWebPresenceNodeFragmentDoc = `
    fragment MarketWebPresenceNode on MarketWebPresence {
  rootUrls {
    ...MarketWebPresenceRootUrlNode
  }
}
    `;
export const MarketWebPresenceEdgesFragmentDoc = `
    fragment MarketWebPresenceEdges on MarketWebPresenceConnection {
  edges {
    node {
      ...MarketWebPresenceNode
    }
    cursor
  }
}
    `;
export const MarketNodeFragmentDoc = `
    fragment MarketNode on Market {
  id
  name
  handle
  webPresences(first: 250) {
    ...MarketWebPresenceEdges
  }
}
    `;
export const MarketEdgesFragmentDoc = `
    fragment MarketEdges on MarketConnection {
  edges {
    node {
      ...MarketNode
    }
    cursor
  }
}
    `;
